module.exports = __webpack_public_path__ + "assets/ruler.f548c693.svg";